const VideoContentColumn = [
    {
        id: "desiredStatus",
        label: "status",
        style: { custom: { width: 36 } },
        disabled: true,
        checked: true,
        sortable: false,
        useInAutocomplete: true,
    },
    {
        id: "name",
        label: "Name",
        style: { custom: { flex: 1, pl: 0, width: "calc(100% - 156px)" } },
        disabled: true,
        checked: true,
        sortable: true,
        useInAutocomplete: true,
    },
    {
        id: "duration",
        label: "Duration",
        style: { custom: { width: 120 } },
        disabled: false,
        checked: true,
        sortable: false,
        useInAutocomplete: true,
    },
];

const MusicContentColumn = [
    {
        id: "desiredStatus",
        label: "status",
        style: { custom: { width: 36 } },
        disabled: true,
        checked: true,
        sortable: true,
        useInAutocomplete: true,
    },
    {
        id: "name",
        label: "Name",
        style: { custom: { flex: 1, pl: 0, width: "calc(100% - 36px)" } },
        disabled: true,
        checked: true,
        sortable: false,
        useInAutocomplete: true,
    },
];

const PeopleContentColumn = [
    {
        id: "desiredStatus",
        label: "status",
        style: { custom: { width: 36 } },
        disabled: true,
        checked: true,
        sortable: true,
        useInAutocomplete: true,
    },
    {
        id: "name",
        label: "Name",
        style: { custom: { flex: 1, pl: 0, width: "calc(100% - 36px)" } },
        disabled: true,
        checked: true,
        sortable: false,
        useInAutocomplete: true,
    },
];

const PhotoContentColumn = [
    {
        id: "desiredStatus",
        label: "status",
        style: { custom: { width: 36 } },
        disabled: true,
        checked: true,
        sortable: true,
        useInAutocomplete: true,
    },
    {
        id: "name",
        label: "Name",
        style: { custom: { flex: 1, pl: 0, width: "calc(100% - 36px)" } },
        disabled: true,
        checked: true,
        sortable: false,
        useInAutocomplete: true,
    },
];

const CustomContentColumn = [
    {
        id: "desiredStatus",
        label: "status",
        style: { custom: { width: 36 } },
        disabled: true,
        checked: true,
        sortable: true,
        useInAutocomplete: true,
    },
    {
        id: "name",
        label: "Name",
        style: { custom: { flex: 1, pl: 0, width: "calc(100% - 36px)" } },
        disabled: true,
        checked: true,
        sortable: false,
        useInAutocomplete: true,
    },
];

export { VideoContentColumn, CustomContentColumn, PhotoContentColumn, MusicContentColumn, PeopleContentColumn };
